import { PRODUCT_KEY } from "@opengov/components-nav-bar";
import { IntlShape } from "react-intl";
import { GlobalNavApplicationId } from "../types";

export type GetAppNameParams = {
  activeProductKey: PRODUCT_KEY | undefined;
  intl: IntlShape;
  activeAppKey?: GlobalNavApplicationId;
};

export const getAppName = ({ activeProductKey, intl, activeAppKey }: GetAppNameParams): string => {
  if (!activeProductKey) return intl.formatMessage({ defaultMessage: "Budgeting & Performance" });

  if (activeProductKey === "perfmgmt") {
    return intl.formatMessage({ defaultMessage: "Performance Management" });
  }

  if (activeProductKey === "reporting") {
    if (activeAppKey === "reportsPublicServicePlatform" || activeAppKey === "dataPublicServicePlatform") {
      return intl.formatMessage({ defaultMessage: "Reporting" });
    }
    return intl.formatMessage({ defaultMessage: "Reporting & Transparency" });
  }

  return intl.formatMessage({ defaultMessage: "Budgeting & Performance" });
};
